import { render } from "./MessengerView.vue?vue&type=template&id=2880d28c&scoped=true"
import script from "./MessengerView.vue?vue&type=script&lang=js"
export * from "./MessengerView.vue?vue&type=script&lang=js"

import "./MessengerView.vue?vue&type=style&index=0&id=2880d28c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2880d28c"]])

export default __exports__